/**
 * Check if a given pathname points to an admin space
 */
export const checkIfAdminRoute = (pathname: string) =>
  pathname.split('/')[3] === 'admin' || pathname.split('/')[2] === 'admin';
